export default __webpack_public_path__ + "static/media/trincheta-centro-nuevo-transparent.d0c746e3.png";